export default "__VITE_ASSET__Di3eLw3j__"